export default __webpack_public_path__ + "static/media/copilot.525a16b2.png";